import React from 'react';
import PropTypes from 'prop-types';
import './SelectableImage.scss';

const SelectableImage = ({ label, name, options, onClick, onChange }) => (
  <ul
    className={`selectable-image-component options-${
      options.length <= 3 ? 'basic' : 'multiple'
    }`}
  >
    {label && (
      <label className='selectable-image-component__title'>{label}</label>
    )}
    {options.map((option) => (
      <li key={option.id}>
        <input
          className='selectable-image-component__input'
          id={option.id}
          type='radio'
          name={name}
          value={option.value}
          onClick={onClick}
          onChange={onChange}
        />
        <label
          style={{
            backgroundImage: `url(${option.srcImage})`,
          }}
          className='selectable-image-component__label'
          htmlFor={option.id}
        >
          <div
            className='selectable-image-component__label__check'
            alt='checkbox'
          ></div>
        </label>
      </li>
    ))}
  </ul>
);

SelectableImage.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      srcImage: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
};

export default SelectableImage;
